






















import Vue from 'vue';
import axios from 'axios';
import RecordSelect from './RecordSelect.vue';

export default Vue.extend({
    name: 'CreateFillerBetaPdf',
    components: { RecordSelect },
    props: [ 'template' ],
    data() {
        return {
            disableButton: false,
            contactId: '',
            companyId: '',
            showPDFLink: false,
            PDFLink: ''
        }
    },
    methods: {
        submit() {
            if(!this.contactId && !this.companyId) {
                alert('Select a contact or company first.');
                return;
            }
            this.disableButton = true;
            axios.post(`${this.$store.state.apiUrl}/filler`, {
                template: this.template,
                contactId: this.contactId || null,
                companyId: this.companyId || null
            })
                .then(resp => {
                    this.disableButton = false;
                    this.PDFLink = `${this.$store.state.apiUrl}/pdf/${resp.data}`;
                    this.showPDFLink = true;
                })
                .catch(e => {
                    console.log(e.response?.data ? e.response.data : e);
                    if(e.response?.data == 'HS_ERROR') {
                        alert('There was an error retrieving info from HubSpot. Make sure the selected contact/company still exists.');
                    } else if(e.response?.data == 'FIELD_ERROR') {
                        alert('There was an error generating your PDF. This error may have occured because you have specified form fields that do not exist in your template.');
                    } else {
                        alert('There was an error.');
                    }
                    this.disableButton = false;
                })
        },
        close() {
            this.$emit('close');
        }
    }
})
